<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">  
        <el-row :gutter="12" class="normalFont">
          <el-col :span="8"  >      
            <font-awesome-icon icon="users"  size="3x"  :style="{ color: '#e88a2a' }" /><br>
            {{$t('field.statTarget1_1_1')}} <font class="importantFont">{{customerCnt}}</font> {{$t('field.statTarget1_1_2')}} <br>             
            {{$t('field.statTarget1_2_1')}} <font class="importantFont">{{countryCnt}}</font> {{$t('field.statTarget1_2_2')}}
          </el-col>
          <el-col :span="8" style="text-align:center">
            <font-awesome-icon icon="phone-volume" size="3x" :style="{ color: '#3493bd' }" /><br>
            {{$t('field.statTarget2_1_1')}} <font class="importantFont">{{feedbackCnt}}</font> {{$t('field.statTarget2_1_2')}} <br>             
            {{$t('field.statTarget2_2_1')}} <font class="importantFont">{{totalFeedbackCnt}}</font> {{$t('field.statTarget2_2_2')}}
          </el-col>
          <el-col :span="8" style="text-align:center">
            <font-awesome-icon icon="wrench" size="3x"   :style="{ color: '#51a755' }" /><br>
            {{$t('field.statTarget3_1_1')}} <font class="importantFont">{{rmaCnt}}</font> {{$t('field.statTarget3_1_2')}} <br>             
            {{$t('field.statTarget3_2_1')}} <font class="importantFont">{{totalRmaCnt}}</font> {{$t('field.statTarget3_2_2')}}
          </el-col>
        </el-row>

    </el-main>
  </div>
</template>

<script>

import Breadcrumb from '../components/Breadcrumb'
import { apiGetCustomerCnt, apiGetCountryCnt, apiGetFeedbackMonthlyCnt, apiGetTotalFeedbackCnt,apiGetRmaCntMonthly, apiGetTotalRmaCnt } from "../../utils/api.js";
import authHeader from "../../services/auth-header";

export default {
  name: 'statTarget',
  data() {    
    return {
      customerCnt:'0',
      countryCnt:'0',
      feedbackCnt:'0',
      totalFeedbackCnt:'0',
      rmaCnt:'0',
      totalRmaCnt:'0'

    };
  }, 
  components: {
    Breadcrumb

  },
  mounted() {
    this.findData()
  },
  methods: {
    findData(){      

      apiGetCustomerCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.customerCnt = response.data;
        }
      }).catch((err) => { console.log(err); });

      apiGetCountryCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.countryCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
      apiGetFeedbackMonthlyCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.feedbackCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
      apiGetTotalFeedbackCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.totalFeedbackCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
      apiGetRmaCntMonthly({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.rmaCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
      apiGetTotalRmaCnt({ headers: authHeader()}).then((response) => {   
        if(response.status == 200 && response.data !=null){
          this.totalRmaCnt = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
   
  }
}; 
</script>
<style scoped>
.normalFont {
  font-size: 20px; 
  text-align:center;
}

.importantFont{
  font-size: 40px; 
  color: #e82a2a;
}
</style>
